// activities
import profileIcon from 'Assets/img/svg/profile/profileIcon.svg';
import shopToyIcon from 'Assets/img/svg/shopToys/shopToyIcon.svg';
import resourcesIcon from 'Assets/img/svg/resources/resourcesIcon.svg';
import milestonesIcon from 'Assets/img/svg/milestone/milestonesIcon.svg';
import activitiesIcon from 'Assets/img/svg/activities/activitiesIcon.svg';
import exerciseIcon from 'Assets/img/svg/exercises/exerciseIcon.svg';
import profileBGWeb from 'Assets/img/svg/profile/profileBGWeb.svg';
import milestoneBGWeb from 'Assets/img/svg/milestone/milestoneBGWeb.svg';
import exerciseBGWeb from 'Assets/img/svg/exercises/exerciseBGWeb.svg';
import activitiesBGWeb from 'Assets/img/svg/activities/activitiesBGWeb.svg';
import resourcesBGWeb from 'Assets/img/svg/resources/resourcesBGWeb.svg';
import shopToysBGWeb from 'Assets/img/svg/shopToys/shopToysBGWeb.svg';
import exerciseMenuIcon from 'Assets/img/svg/exercises/menuIcon.svg'
import profileMenuIcon from 'Assets/img/svg/profile/menuIcon.svg';
import milestoneMenuIcon from 'Assets/img/svg/milestone/menuIcon.svg';
import resourcesMenuIcon from 'Assets/img/svg/resources/menuIcon.svg';
import activitiesMenuIcon from 'Assets/img/svg/activities/menuIcon.svg';
import shopMenuIcon from 'Assets/img/svg/shopToys/menuIcon.svg';
//categories
import fineMotorBGWeb from 'Assets/img/svg/Backgrounds/fineMotor/fineMotorBGWeb.svg';
import fineMotorBgMobile from 'Assets/img/svg/Backgrounds/fineMotor/bgMobile.svg';
import cognitiveBGWeb from 'Assets/img/svg/Backgrounds/cognitive/cognitiveBGWeb.svg';
import cognitiveBgMobile from 'Assets/img/svg/Backgrounds/cognitive/bgMobile.svg';
import communicationBGWeb from 'Assets/img/svg/Backgrounds/communication/communicationBGWeb.svg';
import communicationBgMobile from 'Assets/img/svg/Backgrounds/communication/bgMobile.svg';
import grossMotorBGWeb from 'Assets/img/svg/Backgrounds/grossMotor/grossMotorBGWeb.svg';
import grossMotorBgMobile from 'Assets/img/svg/Backgrounds/grossMotor/bgMobile.svg';
import sensoryBGWeb from 'Assets/img/svg/Backgrounds/sensory/sensoryBGWeb.svg';
import sensoryBgMobile from 'Assets/img/svg/Backgrounds/sensory/bgMobile.svg';
import socialEmotionalBGWeb from 'Assets/img/svg/Backgrounds/socialEmotional/socialEmotionalBGWeb.svg';
import socialEmotionalBgMobile from 'Assets/img/svg/Backgrounds/socialEmotional/bgMobile.svg';
import fineMotorIcon from 'Assets/img/svg/Backgrounds/fineMotor/fineMotorIcon.svg';
import cognitiveIcon from 'Assets/img/svg/Backgrounds/cognitive/cognitiveIcon.svg';
import communicationIcon from 'Assets/img/svg/Backgrounds/communication/communicationIcon.svg';
import grossMotorIcon from 'Assets/img/svg/Backgrounds/grossMotor/grossMotorIcon.svg';
import sensoryIcon from 'Assets/img/svg/Backgrounds/sensory/sensoryIcon.svg';
import socialEmotionalIcon from 'Assets/img/svg/Backgrounds/socialEmotional/socialEmotionalIcon.svg';

// budges
import active from 'Assets/img/svg/budges/active.svg';
import inactive from 'Assets/img/svg/budges/inActive.svg';

// resources 
import ResourceIcon1to2 from 'Assets/img/resources/Resource-Icons-1to2-transparent.png';
import ResourceIcons2to3 from 'Assets/img/resources/Resource-Icons-2to3-transparent.png';
import ResourceIcon3to4Transparent  from 'Assets/img/resources/Resource-Icons-3to4-text-transparent.png';
import ResourceBirth from 'Assets/img/resources/Resource-Icons-Birth-transparent.png';
import ResourceIconChildDevelopment from 'Assets/img/resources/Resource-Icons-Child-Development-transparent.png'
import ResourceIconCognitive from 'Assets/img/resources/Resource-Icons-Cognitive-transparent.png';
import ResourceIconDevelopmentChallenges from 'Assets/img/resources/Resource-Icons-Developmental-Challenges-transparent.png';
import ResourceIconFineMotor from 'Assets/img/resources/Resource-Icons-Fine-Motor-transparent.png';
import ResourceIconGiftedChildren from 'Assets/img/resources/Resource-Icons-Gifted-Children-transparent.png';
import ResourceCategoryGrossMotor from 'Assets/img/resources/Resource-Icons-Gross-Motor-transparent.png';
import ResourceIconLanguage from 'Assets/img/resources/Resource-Icons-Language-transparent.png';
import ResourceIconSelfCare from 'Assets/img/resources/Resource-Icons-Self-Care-Parents-transparent.png';
import ResourceIconSensory from 'Assets/img/resources/Resource-Icons-Sensory-transparent.png';
import ResourceIconSocialEmotion from 'Assets/img/resources/Resource-Icons-Social-Emotional-transparent.png'


//routes
import { Routes } from 'Utils/Route';

export const resource_images = [
	{ResourceIcon1to2},
	{ResourceIcons2to3},
	{ResourceIcon3to4Transparent},
	{ResourceBirth},
	{ResourceIconChildDevelopment},
	{ResourceIconCognitive},
	{ResourceIconDevelopmentChallenges},
	{ResourceIconFineMotor},
	{ResourceIconGiftedChildren},
	{ResourceCategoryGrossMotor},
	{ResourceIconLanguage},
	{ResourceIconSelfCare},
	{ResourceIconSensory},
	{ResourceIconSocialEmotion}
]

export const options = [
	{
		id: 1,
		name: 'Leanne Graham',
	},
];
export const icons = [
	fineMotorIcon,
	cognitiveIcon,
	communicationIcon,
	grossMotorIcon,
	sensoryIcon,
	socialEmotionalIcon,
];

export const contents = [
	{
		id: 1,
		url: '/your-details',
		backgroundImage: profileBGWeb,
		type: 'Profile',
		width: '100%',
		description: 'Update your information and manage your membership.',
		icon: profileIcon,
		backgroundColor: '#F5CEC7',
		budge: active,
		external:false,
		menuIcon:profileMenuIcon
	},
	{
		id: 2,
		url: '/milestoneCategories',
		type: 'Milestones',
		width: '100%',
		description: 'Track your child’s upcoming milestones.',
		icon: milestonesIcon,
		menuIcon:milestoneMenuIcon,
		backgroundImage: milestoneBGWeb,
		backgroundColor: '#E89897',
		budge: active,
		external:false,
	},
	{
		id: 3,
		url: Routes.ExerciseHome,
		backgroundImage: exerciseBGWeb,
		type: 'Exercises',
		width: '100%',
		description: 'Your list of daily exercises from which to choose.',
		icon: exerciseIcon,
		menuIcon:exerciseMenuIcon ,
		backgroundColor: '#E89897',
		budge: inactive,
		external:false,
	},
	{
		id: 4,
		url: '/timelines',
		backgroundImage: activitiesBGWeb,
		type: 'Activities',
		width: '100%',
		description: `Skills-based toys & activities related to Premium Members' monthly Toolbox.`,
		icon: activitiesIcon,
		backgroundColor: '#FFB284',
		budge: inactive,
		external:false,
		menuIcon:activitiesMenuIcon
	},
	{
		id: 5,
		url: Routes.Skills,
		backgroundImage: resourcesBGWeb,
		type: 'Resources',
		menuIcon:resourcesMenuIcon,
		width: '100%',
		description: 'Articles on child development, wellness and self care.',
		icon: resourcesIcon,
		backgroundColor: '#C7C19D',
		budge: inactive,
		external:false,
	},
	{
		id: 6,
		url: 'https://www.adventuretowntoys.com/',
		backgroundImage: shopToysBGWeb,
		type: 'Shop toys',
		width: '100%',
		description: 'Shop our selection of unique developmental toys.',
		icon: shopToyIcon,
		backgroundColor: '#B8AE74',
		budge: active,
		external:true,
		menuIcon:shopMenuIcon
	},
];
export const categories = [
	{

		id: 1,
		url: '/',
		type: 'Gross Motor',
		width: '100%',
		description:
			'Development of the larger muscles of the neck, arms, legs, and torso that aid in sitting up, crawling, walking, jumping and running.',
		icon: grossMotorIcon,
		backgroundImage: grossMotorBGWeb,
		bgImageMobile: grossMotorBgMobile,
		backgroundColor: '#E89897',
		// budge: inactive,
		budge: inactive,
		achievedbudge: active
		
	},
	{
		id: 2,
		url: '/',
		backgroundImage: fineMotorBGWeb,
		bgImageMobile: fineMotorBgMobile,
		type: 'Fine Motor',
		width: '100%',
		description:
			'Development of the muscles in the hands, fingers and wrists that aid in handling objects and writing.',
		icon: fineMotorIcon,
		backgroundColor: '#F5CEC7',
		budge: inactive,
		achievedbudge: active
	},
	{
		id: 3,
		url: '/',
		backgroundImage: cognitiveBGWeb,
		bgImageMobile: cognitiveBgMobile,
		type: 'Cognitive',
		width: '100%',
		description:
			'Development of intelligence, reasoning, information processing and memory that aid in understanding and problem-solving.',
		icon: cognitiveIcon,
		backgroundColor: '#E89897',
		// budge: active,
		budge: inactive,
		achievedbudge: active
	},
	{
		id: 4,
		url: '/',
		backgroundImage: socialEmotionalBGWeb,
		bgImageMobile: socialEmotionalBgMobile,
		type: 'Social Emotional',
		width: '100%',
		description: `Development of an understanding of one's and other's emotions,  as well as awareness of how to behave in different situations.`,
		icon: socialEmotionalIcon,
		backgroundColor: '#FFB284',
		// budge: inactive,
		budge: inactive,
		achievedbudge: active
	},
	{
		id: 5,
		url: '/',
		backgroundImage: sensoryBGWeb,
		bgImageMobile: sensoryBgMobile,
		type: 'Sensory',
		width: '100%',
		description: `Development of the brain's ability to  receive and respond to information that comes in through the senses : touch, sound, smell, taste, and sight.`,
		icon: sensoryIcon,
		backgroundColor: '#C7C19D',
		// budge: active,
		budge: inactive,
		achievedbudge: active
	},
	{
		id: 6,
		url: '/',
		backgroundImage: communicationBGWeb,
		bgImageMobile: communicationBgMobile,
		type: 'Communication',
		width: '100%',
		description:
			'Development of non-verbal communication skills,  language and speech that aids in social communication.',
		icon: communicationIcon,
		backgroundColor: '#B8AE74',
		// budge: inactive,
		budge: inactive,
		achievedbudge: active
	},
];




export const exerciseCategories = [
	{

		id: 1,
		url: '/',
		type: 'Gross Motor',
		width: '100%',
		description:
			'Get those big muscles moving with exercises that build strength in the neck, legs, arms and core muscles.',
		icon: grossMotorIcon,
		backgroundImage: grossMotorBGWeb,
		bgImageMobile: grossMotorBgMobile,
		backgroundColor: '#E89897',
		// budge: inactive,
		budge: inactive,
		achievedbudge: active

		
	},
	{
		id: 2,
		url: '/',
		backgroundImage: fineMotorBGWeb,
		bgImageMobile: fineMotorBgMobile,
		type: 'Fine Motor',
		width: '100%',
		description:
			'Hands-on exercises (See what I did there?) that build dexterity, finger isolation, hand strength and pre-writing skills.',
		icon: fineMotorIcon,
		backgroundColor: '#F5CEC7',
		budge: inactive,
		achievedbudge: active
	},
	{
		id: 3,
		url: '/',
		backgroundImage: cognitiveBGWeb,
		bgImageMobile: cognitiveBgMobile,
		type: 'Cognitive',
		width: '100%',
		description:
			'Brain-building exercises that help with sequencing, problem-solving, reasoning, information processing and memory.',
		icon: cognitiveIcon,
		backgroundColor: '#E89897',
		// budge: active,
		budge: inactive,
		achievedbudge: active
	},
	{
		id: 4,
		url: '/',
		backgroundImage: socialEmotionalBGWeb,
		bgImageMobile: socialEmotionalBgMobile,
		type: 'Social Emotional',
		width: '100%',
		description: `Exercises that aid in the development of self-regulation, emotional intelligence and situational awareness.`,
		icon: socialEmotionalIcon,
		backgroundColor: '#FFB284',
		// budge: inactive,
		budge: inactive,
		achievedbudge: active
	},
	{
		id: 5,
		url: '/',
		backgroundImage: sensoryBGWeb,
		bgImageMobile: sensoryBgMobile,
		type: 'Sensory',
		width: '100%',
		description: `Sensory stimulating exercises that help with processing and integration of information received through the eyes, ears, nose, mouth, hands and feet.`,
		icon: sensoryIcon,
		backgroundColor: '#C7C19D',
		// budge: active,
		budge: inactive,
		achievedbudge: active
	},
	{
		id: 6,
		url: '/',
		backgroundImage: communicationBGWeb,
		bgImageMobile: communicationBgMobile,
		type: 'Communication',
		width: '100%',
		description:
			'Say a few words in order to teach communication skills through non-verbal, language and speech-related exercises.',
		icon: communicationIcon,
		backgroundColor: '#B8AE74',
		// budge: inactive,
		budge: inactive,
		achievedbudge: active
	},
];


export const upcoming = [
	{
		id: 1,
		url: '/',
		backgroundImage: fineMotorBGWeb,
		type: 'Fine Motor',
		width: '100%',
		description:
			'Development of the muscles in the hands, fingers and wrists that aid in handling objects and writing.',
		icon: fineMotorIcon,
		backgroundColor: '#F5CEC7',
		budge: active,
	},
	{
		id: 2,
		url: '/',
		type: 'Gross Motor',
		width: '100%',
		description:
			'Development of the larger muscles of the neck, arms, legs, and torso that aid in sitting up, crawling, walking, jumping and running.',
		icon: grossMotorIcon,
		backgroundImage: grossMotorBGWeb,
		backgroundColor: '#E89897',
		budge: inactive,
	},
	{
		id: 3,
		url: '/',
		backgroundImage: cognitiveBGWeb,
		type: 'Cognitive',
		width: '100%',
		description:
			'Development of intelligence, reasoning, information processing and memory that aid in understanding and problem-solving.',
		icon: cognitiveIcon,
		backgroundColor: '#E89897',
		budge: active,
	},
	{
		id: 4,
		url: '/',
		backgroundImage: socialEmotionalBGWeb,
		type: 'Social Emotional',
		width: '100%',
		description: `Development of an understanding of one's and other's emotions,  as well as awareness of how to behave in different situations.`,
		icon: socialEmotionalIcon,
		backgroundColor: '#FFB284',
		budge: inactive,
	},
	{
		id: 5,
		url: '/',
		backgroundImage: sensoryBGWeb,
		type: 'Sensory',
		width: '100%',
		description: `Development of the brain's ability to  receive and respond to information that comes in through the senses : touch, sound, smell, taste, and sight.`,
		icon: sensoryIcon,
		backgroundColor: '#C7C19D',
		budge: '',
	},
	{
		id: 6,
		url: '/',
		backgroundImage: communicationBGWeb,
		type: 'Communication',
		width: '100%',
		description:
			'Development of non-verbal communication skills,  language and speech that aids in social communication.',
		icon: communicationIcon,
		backgroundColor: '#B8AE74',
		budge: active,
	},
];
export const milestonesIcons = [
	{
		id: 1,
		icon: fineMotorIcon,
	},
	{
		id: 2,
		icon: grossMotorIcon,
	},
	{
		id: 3,
		icon: cognitiveIcon,
	},
	{
		id: 4,
		icon: socialEmotionalIcon,
	},
	{
		id: 5,
		icon: sensoryIcon,
	},
];

export const radioButtonItems = [
	{ id: 1, label: 'Girl', value: 'girl' },
	{ id: 2, label: 'Boy', value: 'boy' },
];
export const conditions = [
	{
		id: 1,
		name: 'no',
	},
	{
		id: 2,
		name: 'yes',
	},
];
export const conditionsArchived = [
	{
		id: 1,
		name: 'Cancel',
	},
	{
		id: 2,
		name: 'Confirm',
	},
];

export const dropdown = [
	{ title: 'The Shawshank Redemption', year: 1994 },
	{ title: 'Requiem for a Dream', year: 2000 },
	{ title: 'Amélie', year: 2001 },
	{ title: 'Monty Python and the Holy Grail', year: 1975 },
];
